// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1612":"0b699112612e01b5","7901":"8d29d34647650240"}[chunkId] + ".js";
};